<ng-container *transloco="let t">
  <div tabindex="0" class="datepicker-start" (focus)="startFocus()"></div>
  <div
    class="datepicker-container"
    role="dialog"
    [attr.aria-label]="label ?? 'Datepicker'"
  >
    <div class="datepicker-head">
      <div>
        <span class="month" aria-live="polite">{{ months[month] }}</span>

        @if (selectMode === SelectMode.Date) {
          <button
            type="button"
            class="prev-month-btn icon-btn next-focus"
            (click)="prev()"
            [attr.disabled]="disablePrev ? '' : undefined"
            [attr.aria-label]="t('datepicker_aria_previous_month')"
            tabindex="0"
          >
            <lib-icon name="chevron-left" size="small"></lib-icon>
          </button>
        }

        @if (selectMode === SelectMode.Date) {
          <button
            type="button"
            class="next-month-btn icon-btn next-focus"
            (click)="next()"
            [attr.disabled]="disableNext ? '' : undefined"
            [attr.aria-label]="t('datepicker_aria_next_month')"
            tabindex="0"
          >
            <lib-icon name="chevron-right" size="small"></lib-icon>
          </button>
        }
      </div>
      <div>
        <span>{{ year }}</span>
        <button
          class="icon-btn year-btn next-focus"
          type="button"
          [attr.aria-label]="
            selectMode === SelectMode.Date
              ? t('datepicker_aria_open_year_view')
              : t('datepicker_aria_open_calendar_view')
          "
          (click)="
            setSelectMode(
              selectMode === SelectMode.Date ? SelectMode.Year : SelectMode.Date
            )
          "
          tabindex="0"
        >
          @if (selectMode === SelectMode.Year) {
            <lib-icon name="chevron-up" size="small"></lib-icon>
          }
          @if (selectMode === SelectMode.Date) {
            <lib-icon name="chevron-down" size="small"></lib-icon>
          }
        </button>
      </div>
    </div>
    <div class="datepicker-body">
      @switch (selectMode) {
        @case (SelectMode.Date) {
          <lib-date-select
            [year]="year"
            [month]="month"
            [initialDate]="
              initialDate?.getFullYear() === year &&
              initialDate?.getMonth() === month
                ? initialDate?.getDate()
                : undefined
            "
            [minDate]="
              minDate?.getFullYear() === year && minDate?.getMonth() === month
                ? minDate?.getDate()
                : undefined
            "
            [maxDate]="
              maxDate?.getFullYear() === year && maxDate?.getMonth() === month
                ? maxDate?.getDate()
                : undefined
            "
            [focusDate]="focusDate"
            (selectedDate)="selectDate($event)"
          ></lib-date-select>
        }
        @case (SelectMode.Year) {
          <lib-year-select
            [yearRangeMin]="yearRangeMin"
            [yearRangeMax]="yearRangeMax"
            [initialYear]="initialDate ? initialDate.getFullYear() : undefined"
            [minYear]="minDate ? minDate.getFullYear() : undefined"
            [maxYear]="maxDate ? maxDate.getFullYear() : undefined"
            [focusYear]="focusYear"
            (selectedYear)="selectYear($event)"
          ></lib-year-select>
        }
      }
    </div>
  </div>
  <div tabindex="0" class="datepicker-start" (focus)="endFocus()"></div>
</ng-container>
